import * as yup from "yup";
import { TFunction } from "i18next";
import moment from "moment";
import { ValidationMessagesUtils, ValidationRules } from "../../../utils/yup";
import { SalesQuote } from "../../../models/salesQuote";
import { JobDetails } from "../../../models/job";

export default function createJobSchema(
  t: TFunction,
  job?: JobDetails,
  salesQuote?: SalesQuote
) {
  return yup.object().shape({
    name: yup
      .string()
      .required(ValidationMessagesUtils.createRequiredMessage(t, "jobs.name")),
    customer:
      !job && !salesQuote
        ? yup
            .string()
            .required(
              ValidationMessagesUtils.createRequiredMessage(t, "jobs.client")
            )
        : yup.string(),
    startDate: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "jobs.startDate")
      ),
    endDate: yup
      .string()
      .test("endDateTest", "End Date Test Message", function (value: string) {
        const { startDate } = this.parent;
        return moment(value).isAfter(startDate);
      })
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "jobs.endDate")
      ),
    contractTotal: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "jobs.contractValue")
      ),
    postcode: ValidationRules.getPostcodeRules(yup, t),
    address: yup.string().required(),
    city: yup.string().required(),
    state: yup.string().required(),
  });
}
